import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import VueLazyload from 'vue-lazyload';
import json from "@/assets/json/galleries.json";
 
Vue.use(VueLazyload)

Vue.config.productionTip = true;

import Meta from 'vue-meta';
Vue.use(Meta);

window.image_store = {};
let jsonFile = JSON.parse(JSON.stringify(json));

window.fadeFullScreenText = false;

for (let room in jsonFile["galleries"]) {
  let img = new Image();
  img.src = require("@/assets/galleries/" + jsonFile["galleries"][room][0]["image"]);
  window.image_store[room]= {};
  window.image_store[room]["backgroundImage"] = img;
}



    

export const bus = new Vue();
new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
